import { render, staticRenderFns } from "./no3.vue?vue&type=template&id=96fb3ed0&scoped=true&"
import script from "./no3.vue?vue&type=script&lang=js&"
export * from "./no3.vue?vue&type=script&lang=js&"
import style0 from "./no3.vue?vue&type=style&index=0&id=96fb3ed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fb3ed0",
  null
  
)

export default component.exports